import React, { useMemo } from 'react';
// import { Spinner } from 'react-bootstrap';
export const Loading = ({ size }) => {
    const iconSize = useMemo(() => (size === 'small' ? '1x' : size === 'large' ? '5x' : '3x'), [size]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `fa-${iconSize}` },
            React.createElement(LoadingImage, null))));
};
export function LoadingImage() {
    return React.createElement("i", { className: "fas fa-cog fa-spin" });
}
//# sourceMappingURL=Loading.js.map